import axios from 'axios';
import config from '../../config/config.json'

const instance = axios.create({
  baseURL: config.backEndUrl,
  timeout: config.timeout
});

export default instance